import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

const AppSupport = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 30000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="no-auth">
      <h4>Please contact SONIFI portal admin and ask them to ensure you have the correct permissions and site assignments.</h4>
      <p>
        <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
          Return home
        </a>
      </p>
      <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '-1em' }}>
        (Redirecting in 30 seconds...)
      </p>
    </div>
  );
};

export default AppSupport;
